webpackJsonp([70144966829960],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Button = undefined;
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = exports.Button = _styledComponents2.default.button.withConfig({
	  displayName: 'Button'
	})(['display:inline-block;padding:1rem 1.5rem;border:2px solid transparent;color:#fff;background-color:', ';font-size:1.2rem;line-height:1;transition:all 0.2s ease;cursor:pointer;&:hover,&:focus{color:', ';background-color:#fff;border:2px solid ', ';}'], _config.colors.secondary, _config.colors.secondary, _config.colors.secondary);

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Group = exports.Form = undefined;
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = exports.Form = _styledComponents2.default.form.withConfig({
	  displayName: 'Form'
	})(['margin-bottom:-2rem;padding:2rem 2rem 0 2rem;background-color:', ';'], _config.colors.lighterGray);
	
	var Group = exports.Group = _styledComponents2.default.div.withConfig({
	  displayName: 'Form__Group'
	})(['margin-bottom:2rem;']);

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Textarea = exports.Input = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  resize: vertical;\n'], ['\n  resize: vertical;\n']);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Input = exports.Input = _styledComponents2.default.input.withConfig({
	  displayName: 'Input'
	})(['display:block;width:100%;padding:1rem 1.5rem;border:2px solid ', ';font-size:1.2rem;transition:border-color 0.2s ease;&:hover,&:focus{border-color:', ';outline:none;}::placeholder{color:', ';}'], _config.colors.gray, _config.colors.secondary, _config.colors.gray);
	
	var Textarea = exports.Textarea = Input.withComponent('textarea').extend(_templateObject);

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AccessibleLabel = exports.AccessibleText = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessibleText = exports.AccessibleText = _styledComponents2.default.span.withConfig({
	  displayName: 'ScreenReader__AccessibleText'
	})(['position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;']);
	
	var AccessibleLabel = exports.AccessibleLabel = AccessibleText.withComponent('label');

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Container = __webpack_require__(24);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Title = __webpack_require__(46);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Button = __webpack_require__(221);
	
	var _Input = __webpack_require__(228);
	
	var _Form = __webpack_require__(224);
	
	var _ScreenReader = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FORM_ENDPOINT = "https://formspree.io/team@ninjality.com";
	var FORM_REDIRECT = "https://ninjality.com/contact-sent";
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: "Contact" },
	        _react2.default.createElement("link", { rel: "canonical", href: "https://ninjality.com/contact" }),
	        _react2.default.createElement("meta", { name: "description", content: "Contact the Ninjality team." })
	      ),
	      _react2.default.createElement(
	        _Title2.default,
	        { hasBackButton: true },
	        "Send Us An Email"
	      ),
	      _react2.default.createElement(
	        _Form.Form,
	        { action: FORM_ENDPOINT, method: "post" },
	        _react2.default.createElement("input", {
	          type: "text",
	          name: "_gotcha",
	          value: "",
	          style: { display: "none" }
	        }),
	        _react2.default.createElement("input", { type: "hidden", name: "_next", value: FORM_REDIRECT }),
	        _react2.default.createElement(
	          _Form.Group,
	          null,
	          _react2.default.createElement(
	            _ScreenReader.AccessibleLabel,
	            { htmlFor: "nameInput" },
	            "Name"
	          ),
	          _react2.default.createElement(_Input.Input, {
	            type: "text",
	            name: "name",
	            id: "nameInput",
	            placeholder: "Name",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _Form.Group,
	          null,
	          _react2.default.createElement(
	            _ScreenReader.AccessibleLabel,
	            { htmlFor: "emailInput" },
	            "Email"
	          ),
	          _react2.default.createElement(_Input.Input, {
	            type: "text",
	            name: "email",
	            id: "emailInput",
	            placeholder: "Email",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _Form.Group,
	          null,
	          _react2.default.createElement(
	            _ScreenReader.AccessibleLabel,
	            { htmlFor: "messageInput" },
	            "Message"
	          ),
	          _react2.default.createElement(_Input.Textarea, {
	            name: "message",
	            id: "messageInput",
	            placeholder: "Message",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _Form.Group,
	          null,
	          _react2.default.createElement(
	            _Button.Button,
	            { type: "submit" },
	            "Send"
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-972555ac66e63360711d.js